export const CHAT_LIST_RETRY_LIMIT = 3;
export const CHAT_LIST_REQUEST_TIMEOUT_MS = 15000;

export const isRetryableChatListError = (error) => {
  if (error?.code === 'ERR_CANCELED' || error?.name === 'AbortError') return false;
  const status = Number(error?.response?.status || 0);
  return status === 0 || status === 408 || status === 429 || status >= 500;
};

export const chatListRetryDelay = (error, attempt, now = Date.now(), random = Math.random()) => {
  const status = Number(error?.response?.status || 0);
  const retryAfter = error?.response?.headers?.['retry-after'];
  const retrySeconds = Number(retryAfter);
  const requestedDelay = retryAfter == null
    ? 0
    : Number.isFinite(retrySeconds)
      ? retrySeconds * 1000
      : Math.max(0, Date.parse(retryAfter) - now) || 0;
  const baseDelay = Math.min(30000, 5000 * 2 ** attempt);
  // Browsers turn an overflowing timer into an immediate callback.
  return Math.min(2147483647,
    Math.max(baseDelay, status === 429 ? 30000 : 0, requestedDelay) + Math.floor(random * 1000)
  );
};

// Wait for both requests before releasing the single-flight lock. A failed queue
// request must never be mistaken for a successful empty queue.
export const fetchChatListPair = async (activeRequest, waitingRequest) => {
  const results = await Promise.allSettled([activeRequest, waitingRequest]);
  const failures = results.filter((result) => result.status === 'rejected');
  if (failures.length) {
    const accessFailure = failures.find((result) =>
      [401, 403].includes(Number(result.reason?.response?.status))
    );
    throw (accessFailure || failures[0]).reason;
  }
  return results.map((result) => result.value);
};
